export default "__VITE_ASSET__Y_vlxFX2__"